import React from 'react';
import logoImg from '../../assets/creative-e-learning-logo.png';

interface EntranceLayoutProps {
  children: React.ReactNode;
  user?: {
    name: string;
  };
  /** Vertical alignment of the main content within the viewport.
   * 'center' (default) suits small single-card pages like login.
   * 'start' suits taller pages (dashboards, exams) that shouldn't be
   * pushed down into empty space below the header. */
  contentAlign?: 'center' | 'start';
}

const EntranceLayout: React.FC<EntranceLayoutProps> = ({ children, user, contentAlign = 'center' }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-0 overflow-hidden">
        <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[60%] rounded-full bg-indigo-100/40 blur-3xl mix-blend-multiply"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[40%] h-[50%] rounded-full bg-purple-100/40 blur-3xl mix-blend-multiply"></div>
      </div>

      <header className="bg-[#20295C] shadow-sm py-4 px-8 flex justify-between items-center z-10">
        <div className="flex items-center gap-6">
          <img src={logoImg} alt="Creative e-Learning" className="h-10 w-auto object-contain" />
          <div className="h-8 w-px bg-white/20"></div>
          <span className="text-white text-lg font-medium tracking-wide">Entrance Exam Portal</span>
        </div>
        {user ? (
          <div className="text-gray-200 font-medium">
            Welcome, {user.name}
          </div>
        ) : (
          <div className="flex items-center gap-2 text-sm text-indigo-100">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            <span>Secure & Trusted</span>
          </div>
        )}
      </header>

      {/* Main Content Area - Full width, no sidebar */}
      <main className={`flex-1 flex flex-col items-center p-4 z-10 ${contentAlign === 'start' ? 'justify-start' : 'justify-center'}`}>
        {children}
      </main>
    </div>
  );
};

export default EntranceLayout;
